import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 85D4DC49-5359-4867-A5D1-52C44699387F
 * name chart-bar
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-bar.svg
 * tags
 * - Math 
 */
export const ChartBarIcon = createSvgIcon(<><path d="M22,21H2V3H4V19H6V10H10V19H12V6H16V19H18V14H22V21Z" /></>, 'ChartBarIcon');
export default ChartBarIcon